enum ImageAspectRatioEnum {
	ORIGINAL = 'original',
	SQUARE = 'square'
}

export default ImageAspectRatioEnum;
